import { useState, useEffect } from "react";
import { FiArrowUp } from "react-icons/fi";
import PortfolioChatbot from "./PortfolioChatbot";
import "./FloatingActions.css";

const FloatingActions = () => {
  const [showScroll, setShowScroll] = useState(false);

  // Show scroll-to-top only after scrolling down
  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="floating-actions">
      {showScroll && (
        <button
          className="floating-actions__scroll-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <FiArrowUp size={18} />
        </button>
      )}
      <PortfolioChatbot />
    </div>
  );
};

export default FloatingActions;
